module.exports = __webpack_public_path__ + "static/media/1 11 fylt.3f60ce07.mp3";